// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VzRi","actions":"styles_actions__16yaA","error":"styles_error__3HmZu","message":"styles_message__24sRH"};